import { useEffect, useRef } from "react";
export var useUnmounted = function () {
    var unmounted = useRef(false);
    useEffect(function () { return function () {
        unmounted.current = true;
    }; }, []);
    return unmounted;
};
//# sourceMappingURL=use-unmounted.js.map